import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcJobs = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M4 17.125a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H4Zm8 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm.172-10.5H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4.172l-1.707 1.707a3 3 0 0 1-4.242 0l-1.707-1.707Zm7.828 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.25 3.125a1.25 1.25 0 0 0-2.5 0v3H8.81a.75.75 0 0 0-.53 1.28l3.012 3.013a1 1 0 0 0 1.415 0l3.012-3.013a.75.75 0 0 0-.53-1.28h-1.94v-3Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcJobs");

export { IcJobs };
//# sourceMappingURL=ic-jobs.js.map
